import { DialogContainer } from 'nucleus-guestside-site/src/containers/DialogContainer';
import DialogStyles from 'nucleus-guestside-site/src/containers/styles/Dialog.less';
import React from 'react';
import LoadingIndicator from 'nucleus-widgets/lib/LoadingProgressIndicator/LoadingIndicator';
import Variables from '../dialogs/styles/Variables.less';

export default function LoadingProgressIndicatorWrapper() {
  const loading = 1;
  const delayRenderTime = 1000;
  const dialogConfig = { isOpen: false };
  const dialogContainerContent = {
    loadingChildren: (
      <LoadingIndicator
        classes={DialogStyles}
      />
    )
  };
  const loadingConfig = {
    classes: {
      ...DialogStyles
    },
    style: {
      dragContainer: {
        height: Variables.dialogHeight
      }
    }
  };
  return (
    <DialogContainer
      delayRenderTime={delayRenderTime}
      loading={loading}
      dialogConfig={dialogConfig}
      loadingConfig={loadingConfig}
      dialogContainerContent={dialogContainerContent}
    />
  );
}
